export const excludeProps =
	(excludedPropsNames: string[]) =>
	(propName: PropertyKey): boolean => {
		return !excludedPropsNames.includes(propName as string);
	};
